export const CREATE_PLACE = 'CREATE_PLACE';
export const FETCH_PLACES = 'FETCH_PLACES';
export const FETCH_PLACE = 'FETCH_PLACE';
export const DELETE_PLACE = 'DELETE_PLACE';
export const SAVE_ERROR = 'SAVE_ERROR';